import { render, staticRenderFns } from "./MobileCommunePartnerDisplay.vue?vue&type=template&id=c84d55b4&scoped=true&"
import script from "./MobileCommunePartnerDisplay.vue?vue&type=script&lang=js&"
export * from "./MobileCommunePartnerDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunePartnerDisplay.vue?vue&type=style&index=0&id=c84d55b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84d55b4",
  null
  
)

export default component.exports